import { lazy } from 'react';
import logger from './logger';

export const lazyWithRetry = (componentImport: any) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('fiter:pageHasBeenForceRefreshed') || 'false',
    );

    try {
      const component = await componentImport();

      window.localStorage.setItem('fiter:pageHasBeenForceRefreshed', 'false');
      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem('fiter:pageHasBeenForceRefreshed', 'true');
        window.location.reload();
      } else {
        // The page has already been reloaded
        // Assuming that user is already using the latest version of the application.
        // Let's let the application crash and raise the error.
        logger.log(error);
      }

      throw error;
    }
  });
